import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { WrapperContentStyled } from './styled.jsx';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/error-icon.svg';
import { useDispatch } from 'react-redux';

/**
 * Message error component
 */
export const MessageContent = ({ visible, imageUrl = ErrorIcon, subMessage = '', message = '', description = '' }) => {
  const refWrapper = useRef(null);
  const refContent = useRef(null);
  const [styledCustom, setStyledCustom] = useState(null);
  const [size, setSize] = useState([0, 0]);
  const dispatch = useDispatch();

  const updateSize = React.useCallback(() => {
    setSize([window.innerWidth, window.innerHeight]);
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [visible, updateSize]);

  useEffect(() => {
    const { clientHeight: clientHeightContent } = refContent.current;
    const { clientHeight: clientHeightWrapper } = refWrapper.current;
    if (clientHeightWrapper && clientHeightContent > clientHeightWrapper) setStyledCustom('full-height');
    else setStyledCustom('');
  }, [size, visible, dispatch, message, subMessage]);

  return (
    <WrapperContentStyled className={styledCustom} ref={refWrapper}>
      <div className="content" ref={refContent}>
        <img src={imageUrl} alt={imageUrl} />
        <h1>{message}</h1>
        <p>{subMessage}</p>
        <p><strong>{description}</strong></p>
      </div>
    </WrapperContentStyled>
  );
};

MessageContent.propTypes = {
  /**
   * Image error
   */
  imageUrl: PropTypes.string.isRequired,
  /**
   * Title Error
   */
  message: PropTypes.string,
  /**
   * SubMessage Error
   */
  subMessage: PropTypes.string,
  /**
   * Description Error
   */
  description: PropTypes.string,
  /**
   * True -> Show / False -> Hide
   */
  visible: PropTypes.bool.isRequired
};

